import React from 'react';
import './app-loading.css';

function AppLoading() {
  return (
    <main className='dream-loading-main'>
      <img src='/dream-loading.svg' alt='Loading' width='96' height='96' />
    </main>
  );
}

export default AppLoading;
